const PACKAGED_API = 'https://cam-xs2z.onrender.com'

function isLoopbackApi(url) {
  return /^https?:\/\/(localhost|127\.0\.0\.1)(?::\d+)?$/i.test(String(url || '').trim())
}

function isPackagedHost(hostname) {
  const host = String(hostname || '').toLowerCase()
  return host.includes('vercel.app') || host.includes('cam-chi') || host.includes('camit.app')
}

/**
 * Origine de l'API.
 * En développement local ou sur le réseau privé, on reste sur la même origine
 * pour emprunter le proxy Vite : `localhost` sur un téléphone désignerait
 * le téléphone, pas l'ordinateur.
 */
export function resolveApiBaseUrl({
  configured = typeof import.meta !== 'undefined' ? import.meta.env?.VITE_API_URL : '',
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
} = {}) {
  const value = typeof configured === 'string' ? configured.trim().replace(/\/$/, '') : ''
  if (value && !isLoopbackApi(value)) return value
  if (isPackagedHost(hostname)) return PACKAGED_API
  return ''
}

export function apiUrl(path) {
  const suffix = String(path || '').startsWith('/') ? path : `/${path}`
  return `${resolveApiBaseUrl()}${suffix}`
}
